import React from 'react';
import { observer } from 'mobx-react';
import {
  Box,
  makeStyles,
  Button,
} from '@material-ui/core';
import { VolumeUp, VolumeOff } from '@material-ui/icons';
import Loading from 'react-simple-loading';

import StreamViewPlayer from '../../../StreamViewPlayer/StreamViewPlayer';
import GroupShowStore from '../../../../store/GroupShowStore';


const useStyles = makeStyles((theme) => {

  return {
    twoParticipants: {
      width: '50%',
      maxHeight: '100%',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        maxHeight: '50%',
      },
    },
    oneParticipant: {
      width: '100%',
      maxHeight: '100%',
    },
    videoClass: {
      width: '100%',
      maxHeight: '100%',
    },
    volume: {
      width: '100%',
      height: 30,
      position: 'absolute',
      bottom: 50,
      textAlign: 'left',
      [theme.breakpoints.down('xs')]: {
        top: 85,
        textAlign: 'right',
      },
    },
    icon: {
      fontSize: 32,
      marginLeft: 5,
      [theme.breakpoints.down('xs')]: { marginRight: 5 },
    },
    tipping: {
      position: 'absolute',
      bottom: 10,
      left: 10,
    },
    btn: {
      backgroundColor: '#ac020a',
      border: '1px solid #930209',
      color: '#fff',
      fontSize: 11,
      marginRight: 5,
      '&:hover': { backgroundColor: '#ac020a' },
    },
  };
});

const GroupShow = ({
  isSubscribed,
  onHLSError,
  user,
  onLiveSessionEnd,
}) => {
  const classes = useStyles();
  const {
    streamData,
    username,
    streamMuted,
    groupShowParticipant: {
      participantStreamData,
      participantUsername,
    },
  } = GroupShowStore;
  const wrapperClass = streamData && participantStreamData ? classes.twoParticipants : classes.oneParticipant;

  return (
    <Box
      display="flex"
      flexDirection={{ xs: 'column', md: 'row' }}
      height="100%"
      width="100%"
      justifyContent="center"
      position="relative"
    >
      {streamData && (
        <Box
          alignItems="center"
          className={wrapperClass}
          display="flex"
        >
          <StreamViewPlayer
            anchorUsername={username}
            autoplay={!!isSubscribed}
            gsHost={true}
            isInGroupShow={true}
            loadingOverlay={(loading) =>
              loading && (
                <div className="anchor-live-feed-loading">
                  <Loading color="white" />
                </div>
              )
            }
            streamData={streamData}
            user={user}
            videoClass={classes.videoClass}
            videoId={'myvideo'}
            onHLSError={onHLSError}
            onLiveSessionEnd={onLiveSessionEnd}
          />
        </Box>
      )}
      {participantStreamData && (
        <Box
          alignItems="center"
          className={wrapperClass}
          display="flex"
        >
          <StreamViewPlayer
            anchorUsername={participantUsername}
            autoplay={!!isSubscribed}
            isInGroupShow={true}
            loadingOverlay={(loading) =>
              loading && (
                <div className="anchor-live-feed-loading">
                  <Loading color="white" />
                </div>
              )
            }
            streamData={participantStreamData}
            user={user}
            videoClass={classes.videoClass}
            videoId={'myvideo'}
            onHLSError={onHLSError}
            onLiveSessionEnd={onLiveSessionEnd}
          />
        </Box>
      )}
      {(streamData || participantStreamData) && isSubscribed && (
        <Box className={classes.volume} onClick={() => GroupShowStore.toggleStreamVolume()}>
          {streamMuted ? (
            <VolumeOff className={classes.icon} />
          ) : (
            <VolumeUp className={classes.icon} />
          )}
        </Box>
      )}
    </Box>
  );
};

export default observer(GroupShow);
